import mqStore from 'store/mqStore';
import store from 'store/store';
const onChange = async () => {
    const isTabletPortrait = mqStore.tabletPortrait.get();
    const pageHeaderSelect = store.drawer.get() === 'page-header-select';
    let hasOverlay = !!(store.panel.get() || store.drawer.get());
    if ((pageHeaderSelect && !mqStore.tabletPortrait.get()) || store.drawer.get() === 'menu') {
        hasOverlay = false;
        store.overlay.set(hasOverlay);
        return;
    }
    if ((pageHeaderSelect || store.panel.get() || store.drawer.get() || store.search.get()) && store.drawer.get() !== 'menu') {
        if (((pageHeaderSelect && !mqStore.tabletPortrait.get()) || !mqStore.tabletPortrait.get()))
            store.overlayStrength.set('strength-3');
        else if (store.drawer.get() === 'menu')
            store.overlayStrength.set('strength-3');
        else if (pageHeaderSelect && mqStore.tabletPortrait.get())
            store.overlayStrength.set('strength-2');
        else
            store.overlayStrength.set('strength-3');
    }
    if (store.drawer.get() === 'search' || (store.drawer.get() === 'menu' && isTabletPortrait))
        store.overlayStrength.set('strength-1');
    store.overlay.set(hasOverlay);
};
store.drawer.listen(() => onChange());
store.panel.listen(() => onChange());
mqStore.tabletPortrait.listen(() => onChange());
